import { AxiosResponse } from 'axios';
import { api as companiesApi } from 'services/companiesApi';
import { Employee, EmployeeStatus } from 'types/employee';

export type GetEmployeesType = {
	branchOfficeId?: string;
	name?: string;
	companyBadgeNumber?: string;
	shift?: string;
	status?: string;
	riskProfileIds?: string;
	expositionAreaIds?: string;
	pageNumber?: number;
	pageSize?: number;
};

export const getEmployees = async ({
	branchOfficeId,
	name,
	companyBadgeNumber,
	shift,
	status,
	riskProfileIds,
	expositionAreaIds,
	pageNumber,
	pageSize,
}: GetEmployeesType): Promise<AxiosResponse> => {
	const branchOfficeIdParm = branchOfficeId ? { branchOfficeId } : {};
	const nameParm = name ? { name } : {};
	const companyBadgeNumberParm = companyBadgeNumber
		? { companyBadgeNumber }
		: {};
	const shiftParm = shift ? { shift } : {};
	const statusParm = status ? { status } : {};
	const riskProfileIdsParm = riskProfileIds ? { riskProfileIds } : {};
	const expositionAreaIdsParm = expositionAreaIds ? { expositionAreaIds } : {};

	return await companiesApi.get('/employees', {
		params: {
			pageNumber,
			pageSize,
			...branchOfficeIdParm,
			...nameParm,
			...companyBadgeNumberParm,
			...shiftParm,
			...statusParm,
			...riskProfileIdsParm,
			...expositionAreaIdsParm,
		},
	});
};

export async function getCsvEmployee(
	branchOfficeId?: string,
	name?: string,
	companyBadgeNumber?: string,
	shift?: string,
	status?: string,
	selectedEmployees?: string,
): Promise<AxiosResponse> {
	return await companiesApi.get(`/employees/export`, {
		params: {
			branchOfficeId,
			name,
			companyBadgeNumber,
			shift,
			status,
			employees: selectedEmployees,
		},
	});
}

export const postStatusEmployee = async (
	employeeIds: string[],
	status: EmployeeStatus,
): Promise<AxiosResponse> => {
	const payload = {
		status,
		employees: employeeIds,
	};

	return await companiesApi.post(`/employees/activation`, payload);
};

export const getEmployee = async (
	employeeId: string,
): Promise<AxiosResponse> => {
	return await companiesApi.get(`/employees/${employeeId}`);
};

export const postEmployee = async (employee: any): Promise<AxiosResponse> => {
	return await companiesApi.post(`/employees`, employee);
};

export const putEmployee = async (
	id: string,
	employee: any,
): Promise<AxiosResponse> => {
	return await companiesApi.put(`/employees/${id}`, employee);
};

export const putAssignJogProfile = async (
	employees: Employee[],
	profileId: string,
): Promise<AxiosResponse> => {
	const payload = {
		profileId: profileId,
		employeeIds: employees.map((employee: Employee) => employee.id),
	};

	return await companiesApi.put(`/job-profiles/employees`, payload);
};
